import React, { useContext, useEffect, useState } from 'react'
import AuthContext from '../../auth/Context/AuthContext';
import Swal from 'sweetalert2';
import axios from '../../adapters/API/axios';
import Cookies from 'js-cookie';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { MdGroups, MdOutlineTouchApp } from 'react-icons/md';
import { FiLogOut } from "react-icons/fi";
import { BsBuildingCheck, BsBuildingFillDown, BsBuildingFillUp, BsPersonFill, BsPersonFillCheck } from 'react-icons/bs';
import ModalVisitComp from '../../component/Modal/ModalVisitComponent';
import ModalVisitOutComp from '../../component/Modal/ModalVisitOutComponent';
import { useNavigate } from 'react-router-dom';
import { IoWarningOutline } from 'react-icons/io5';
import { isMobile } from 'react-device-detect';
import NavbarComponent from '../../component/Navbar';

function HomeMobile() {

    const { userInfo, tokens, setTokens, groups, setGroups, setUserInfo } = useContext(AuthContext);
    const [location, setLocation] = useState(null);
    const [placeWork, setPlaceWork] = useState(null)
    const tokenUser = tokens?.token;

    const [openModalVisit, setOpenModalVisit] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const handleOpenModal = () => {
        setOpenModalVisit(true)
    }

    const [openModalVisitOut, setOpenModalVisitOut] = useState(false);
    const handleOpenModalVisitOut = () => {
        setOpenModalVisitOut(true)
    }

    const [visitPlace, setVisitPlace] = useState('');
    const handleCloseModal = () => {
        setOpenModalVisit(false)
        setVisitPlace('');
    }

    const navigate = useNavigate();

    useEffect(() => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    let place
                    if (latitude > -6.160833 && latitude < -6.159412 && longitude > 106.852544 && longitude < 106.853757) {
                        place = "Concordia Jakarta"
                    } else if (latitude > -7.294165632163485 && latitude < -7.2940900226567384 && longitude > 112.76080932919187 && longitude < 112.76098618914922) {
                        place = "Concordia Surabaya"
                    } else if (latitude > -6.993607890824473 && latitude < -6.99291751677812 && longitude > 110.36540596798785 && longitude < 110.36578059787311) {
                        place = "Blok F5 KEI Semarang"
                    } else if (latitude > -6.992061149368572 && latitude < -6.991460821772807 && longitude > 110.35721449736182 && longitude < 110.35778717246941) {
                        place = "Blok K KEI Semarang"
                    } else if (latitude > -7.004179415543319 && latitude < -7.00385529351418 && longitude > 110.4259625312932 && longitude < 110.426270314777) {
                        place = "Concordia Semarang"
                    }
                    else {
                        place = "Diluar kantor"
                    }
                    setPlaceWork(place)
                    setLocation({ latitude, longitude });
                },
                (error) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Tidak dapat mendapatkan lokasi',
                        text: `${error.message}. Harap mengaktifkan lokasi pada perangkat Anda!`,
                    });
                    // console.error( 'Error getting location:', error.message );
                }
            );
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Geolocation tidak support pada browser Anda!',
                text: `Silahkan mengganti atau update versi browser Anda!`,
            });
            // console.error( 'Geolocation is not supported by your browser' );
        }
    }, []);

    const win = window.sessionStorage;

    const handleSubmitAbsen = async (event) => {
        const result = await Swal.fire({
            title: 'Absen Masuk?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Ya',
            cancelButtonText: 'Batal',
        });

        if (result.isConfirmed) {

            event.preventDefault();

            const finaldata = {
                checkin_location: `POINT(${location?.longitude} ${location?.latitude})`,
                user: userInfo?.id,
                checkin_place: placeWork,
            };

            setDisabled(true);

            try {
                const response = await axios.post(`/api/checkin/`, finaldata,
                    {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json',
                            withCredentials: true,
                            Authorization: `Token ` + tokenUser,
                        },
                    }
                );

                const now = new Date();
                const midnight = new Date(now);
                midnight.setHours(24, 0, 0, 0);
                const timeUntilMidnightInSeconds = Math.floor((midnight - now) / 1000);
                // Set a cookie with the calculated max-age
                document.cookie = `checkin=true; max-age=${timeUntilMidnightInSeconds}`;

                Swal.fire({
                    icon: 'success',
                    title: 'Absensi Masuk Berhasil',
                    showConfirmButton: false,
                    timer: 2000
                });

                setDisabled(false);

            } catch (err) {
                console.error(err)
                if (!err?.response) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Warning!',
                        text: 'Terjadi kesalahan saat Absen Masuk',
                    });
                } else if (err.response?.status === 400) {
                    let str = err.response?.data.error;

                    // Fix the single quotes to double quotes so we can parse it as JSON
                    let fixedStr = str.replace(/'/g, '"');

                    try {
                        let parsed = JSON.parse(fixedStr);

                        // Get the error message from "__all__"
                        let message = parsed.__all__?.[0] || "Unknown error";

                        Swal.fire({
                            icon: 'error',
                            title: 'Warning!',
                            text: message,
                        });
                    } catch (e) {
                        // If parsing fails, fallback to showing the original string
                        Swal.fire({
                            icon: 'error',
                            title: 'Warning!',
                            text: "An unexpected error occurred.",
                        });
                    }
                    setDisabled(false);
                }

                setDisabled(false);
            };
        };
    };


    const handleSubmitKeluar = async (event) => {

        const result = await Swal.fire({
            title: 'Absen Pulang?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Ya',
            cancelButtonText: 'Batal',
        });

        if (result.isConfirmed) {

            event.preventDefault();

            const finaldata = {
                checkout_location: `POINT(${location?.longitude} ${location?.latitude})`,
                user: userInfo?.id,
                checkout_place: placeWork,
            };

            setDisabled(true);

            try {
                const response = await axios.post(`/api/checkout/`, finaldata,
                    {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json',
                            withCredentials: true,
                            Authorization: `Token ` + tokenUser,
                        },
                    }
                );

                Swal.fire({
                    icon: 'success',
                    title: 'Absensi Pulang Berhasil',
                    showConfirmButton: false,
                    timer: 2500
                });

                setDisabled(false);

            } catch (err) {
                console.error(err)
                if (!err?.response) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Warning!',
                        text: 'Terjadi kesalahan saat Absen Masuk',
                    });
                } else if (err.response?.status === 400) {
                    let str = err.response?.data.error;

                    // Fix the single quotes to double quotes so we can parse it as JSON
                    let fixedStr = str.replace(/'/g, '"');

                    try {
                        let parsed = JSON.parse(fixedStr);

                        // Get the error message from "__all__"
                        let message = parsed.__all__?.[0] || "Unknown error";

                        Swal.fire({
                            icon: 'error',
                            title: 'Warning!',
                            text: message,
                        });
                    } catch (e) {
                        // If parsing fails, fallback to showing the original string
                        Swal.fire({
                            icon: 'error',
                            title: 'Warning!',
                            text: "An unexpected error occurred.",
                        });
                    }
                    setDisabled(false);
                }

                setDisabled(false);
            };

        }

    };

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmitVisitIn = async (event) => {
        event.preventDefault()

        const finaldata = {
            visitIn_location: `POINT(${location?.longitude} ${location?.latitude})`,
            user: userInfo?.id,
            visitIn_place: visitPlace,
        }

        setDisabled(true);
        setIsSubmitting(true);

        try {
            const response = await axios.post(`/api/visit/visitIn/`, finaldata,
                {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                        withCredentials: true,
                        Authorization: `Token ` + tokenUser,
                    },
                }
            );

            Swal.fire({
                icon: 'success',
                title: 'Visit Masuk diterima',
                showConfirmButton: false,
                timer: 2000
            });

            const visitInData = response?.data?.id; // just the ID

            localStorage.setItem('visitInId', JSON.stringify(visitInData));

            handleCloseModal();
            setDisabled(false);
            setIsSubmitting(false);

        } catch (err) {
            console.error(err)
            if (!err?.response) {
                Swal.fire({
                    icon: 'error',
                    title: 'Warning!',
                    text: 'Terjadi kesalahan saat Absen Masuk',
                });
                setDisabled(false);
                setIsSubmitting(false);
            } else if (err.response?.status === 400) {
                let str = err.response?.data.error;

                // Fix the single quotes to double quotes so we can parse it as JSON
                let fixedStr = str.replace(/'/g, '"');

                try {
                    let parsed = JSON.parse(fixedStr);

                    // Get the error message from "__all__"
                    let message = parsed.__all__?.[0] || "Unknown error";

                    Swal.fire({
                        icon: 'error',
                        title: 'Warning!',
                        text: message,
                    });
                } catch (e) {
                    // If parsing fails, fallback to showing the original string
                    Swal.fire({
                        icon: 'error',
                        title: 'Warning!',
                        text: "An unexpected error occurred.",
                    });
                }

                setDisabled(false);
                setIsSubmitting(false);
            }

            setDisabled(false);
            setIsSubmitting(false);
        };
    };


    const [jamFunction, setJamFunction] = useState('');

    useEffect(() => {
        const updateClock = () => {
            const now = new Date();
            const options = { timeZone: 'Asia/Jakarta', hour: '2-digit', minute: '2-digit', hour12: false };
            const formatter = new Intl.DateTimeFormat('en-US', options);
            setJamFunction(formatter.format(now));
        };

        updateClock(); // Run immediately

        const now = new Date();
        const msToNextMinute = (60 - now.getSeconds()) * 1000; // how many ms to next minute

        const timeout = setTimeout(() => {
            updateClock();
            const interval = setInterval(updateClock, 60000); // now every real minute
            // Store interval to clear later
            window.jamFunctionInterval = interval;
        }, msToNextMinute);

        return () => {
            clearTimeout(timeout);
            clearInterval(window.jamFunctionInterval);
        };
    }, []);


    const [tanggalFunction, setTanggalFunction] = useState('');

    useEffect(() => {
        const today = new Date();
        const options = { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'Asia/Jakarta' };
        setTanggalFunction(new Intl.DateTimeFormat('id-ID', options).format(today));
    }, []);


    const LogoutSession = async () => {
        const confirmLogout = await Swal.fire({
            title: 'Keluar aplikasi?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Keluar',
            cancelButtonText: 'Batal',
        });

        if (!confirmLogout.isConfirmed) {

            return;
        }
        try {
            await axios.post(
                '/api/logout/',
                {},
                {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        withCredentials: true,
                        Authorization: `Token ${tokens.token}`,
                    },
                }
            );

            sessionStorage.removeItem('userInfo');
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('groups');
            setTokens();
            setUserInfo();
            setGroups();
            Swal.fire({
                icon: 'success',
                title: 'Logout Berhasil',
                showConfirmButton: false,
                timer: 2000,
            });
            navigate('/');
        } catch (error) {
            // console.log( error );
            Swal.fire({
                icon: 'error',
                title: 'Warning!',
                text: 'Terhadi kesalahan pada proses Logout!',
            });

            sessionStorage.removeItem('userInfo');
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('groups');
            setTokens();
            setUserInfo();
            setGroups();
            navigate('/');
        }
    };

    const handleIconClick = () => {
        Swal.fire({
            icon: 'warning',
            title: 'Perhatian!',
            html: `
              Harap melakukan absensi pada saat masuk dan pulang bekerja.<br/>
              Jam masuk 08:30 dan jam pulang 18:00, toleransi keterlambatan 15 menit.<br/>
              Jika tidak melakukan absensi maka akan dianggap Alfa atau tidak masuk.
            `,
            confirmButtonText: 'Mengerti',
        });
    };

    return (
        <div id={isMobile ? 'homeMobile' : ''} style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
            {isMobile ?
                (
                    <>
                        <div className='pt-3'>
                            <p className='text-center' style={{ fontFamily: 'Poppins-Regular', fontSize: '18px', marginBottom: '0px' }}>Absensi Mobile</p>
                            <p className='text-center' style={{ fontFamily: 'Poppins-Regular', fontSize: '18px' }}>
                                Concordia Group <IoWarningOutline size={20} color='orange' onClick={handleIconClick} />
                            </p>
                            <p className='text-center' style={{ fontFamily: 'Poppins-Medium', fontSize: '22px', marginBottom: '0px' }}>{userInfo?.first_name} {userInfo?.last_name}</p>
                        </div>
                        <div className='d-flex justify-content-center align-items-center' style={{ flexDirection: 'column', flex: 1, }}>
                            <p style={{ fontFamily: 'Poppins-Medium', fontSize: '40px', margin: '0' }}>
                                {jamFunction}
                            </p>
                            <p style={{ fontFamily: 'Poppins-Regular', fontSize: '20px', margin: '0', color: '#ababab' }}>
                                {tanggalFunction}
                            </p>
                            <div className='my-3'>
                                <Row>
                                    <Col xs={12} className='text-center mb-3'>
                                        <Button variant='btn' className='btnActionMobile btnAction-1' onClick={handleSubmitAbsen} disabled={disabled}>
                                            <MdOutlineTouchApp size={75} />
                                            <p className='pt-3'>
                                                Absen<br />Masuk
                                            </p>
                                        </Button>
                                    </Col>
                                    <Col xs={12} className='text-center mb-3'>
                                        <Button variant='btn' className='btnActionMobile btnAction-2' onClick={handleSubmitKeluar} disabled={disabled}>
                                            <MdOutlineTouchApp size={75} />
                                            <p className='pt-3'>
                                                Absen<br />Pulang
                                            </p>
                                        </Button>
                                    </Col>
                                    <Col xs={12} className='text-center mb-3'>
                                        <Button variant='btn' className='btnActionMobile btnAction-4' onClick={handleOpenModal} disabled={disabled}>
                                            <BsBuildingFillUp size={75} />
                                            <p className='pt-3'>
                                                Visit<br />Masuk
                                            </p>
                                        </Button>
                                    </Col>
                                    <Col xs={12} className='text-center mb-3'>
                                        <Button variant='btn' className='btnActionMobile btnAction-3' onClick={handleOpenModalVisitOut} disabled={disabled}>
                                            <BsBuildingFillDown size={75} />
                                            <p className='pt-3'>
                                                Visit<br />Keluar
                                            </p>
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <footer className='d-flex justify-content-center align-items-center'
                            style={{
                                padding: '10px 0',
                                background: '#000A2E',
                                textAlign: 'center',
                                borderTopRightRadius: '20px',
                                borderTopLeftRadius: '20px',
                                boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
                                backdropFilter: 'blur(5px)',
                                WebkitBackdropFilter: 'blur(5px)',
                            }}
                        >
                            {groups?.includes('HRD GA') || groups?.includes('superuser') ?
                                (
                                    <>
                                        <div className='mx-2' onClick={() => navigate('/data-karyawan')} style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <BsPersonFill size={24} color={'white'} />
                                            <span style={{ fontSize: '12px', color: 'white' }}>Data Karyawan</span>
                                        </div>
                                        <div className='mx-2' onClick={() => navigate('/report')} style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <BsPersonFillCheck size={24} color={'white'} />
                                            <span style={{ fontSize: '12px', color: 'white' }}>Report Absensi</span>
                                        </div>
                                        <div className='mx-2' onClick={() => navigate('/report-visit ')} style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <BsBuildingCheck size={24} color={'white'} />
                                            <span style={{ fontSize: '12px', color: 'white' }}>Report Visit</span>
                                        </div>
                                        <div className='mx-2' onClick={LogoutSession} style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <FiLogOut size={24} color={'white'} />
                                            <span style={{ fontSize: '12px', color: 'white' }}>Logout</span>
                                        </div>
                                    </>
                                )
                                :
                                (
                                    <>
                                        <div className='mx-4' onClick={() => navigate('/data-absensi')} style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <BsPersonFillCheck size={24} color={'white'} />
                                            <span style={{ fontSize: '12px', color: 'white' }}>Data Absensi</span>
                                        </div>
                                        <div className='mx-4' onClick={() => navigate('/data-visit')} style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <BsBuildingCheck size={24} color={'white'} />
                                            <span style={{ fontSize: '12px', color: 'white' }}>Data Visit</span>
                                        </div>
                                        <div className='mx-4' onClick={LogoutSession} style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <FiLogOut size={24} color={'white'} />
                                            <span style={{ fontSize: '12px', color: 'white' }}>Logout</span>
                                        </div>
                                    </>
                                )
                            }
                        </footer>

                    </>
                )
                :
                (
                    <>
                        <>
                            <NavbarComponent />
                            <Container fluid className='text-center'>
                                {isMobile ?
                                    <h1 className='display-6' style={{ fontFamily: 'Poppins-Regular', fontSize: '35px' }}>Absensi Mobile Concordia Group</h1>
                                    :
                                    <h1 className='display-6' style={{ fontFamily: 'Poppins-Regular' }}>Absensi Mobile Concordia Group</h1>
                                }
                                <h3 style={{ fontFamily: 'Poppins-Light' }}>Selamat Datang, {userInfo?.first_name} {userInfo?.last_name}</h3>
                                <Container style={{ maxWidth: '700px' }}>
                                    <p style={{ fontSize: '17px', fontFamily: 'Poppins-Medium' }}>
                                        Selamat datang di Absensi Concordia Group.
                                        Harap melakukan absensi pada mobile devices Anda, agar lokasi  Anda dapat lebih akurat!
                                    </p>
                                </Container>
                            </Container >
                        </>
                    </>
                )
            }

            <ModalVisitComp
                openModalVisit={openModalVisit}
                setOpenModalVisit={setOpenModalVisit}
                visitPlace={visitPlace}
                setVisitPlace={setVisitPlace}
                handleSubmitVisitIn={handleSubmitVisitIn}
                handleCloseModal={handleCloseModal}
                isSubmitting={isSubmitting}
                disabled={disabled}
            />
            <ModalVisitOutComp
                openModalVisitOut={openModalVisitOut}
                setOpenModalVisitOut={setOpenModalVisitOut}
                location={location}
                userInfo={userInfo}
                tokenUser={tokenUser}
                win={win}
            />

        </div>
    )
}

export default HomeMobile
